import { render } from "./LoadingSkeleton.vue?vue&type=template&id=d2436452&scoped=true"
import script from "./LoadingSkeleton.vue?vue&type=script&lang=js"
export * from "./LoadingSkeleton.vue?vue&type=script&lang=js"

import "./LoadingSkeleton.vue?vue&type=style&index=0&id=d2436452&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2981498683/src/lrex-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2436452"]])

export default __exports__